module.exports = __webpack_public_path__ + "static/media/thumb-pathutility.4573986c.png";